/* unplugin-vue-components disabled */import script from "./Profile.vue?vue&type=script&setup=true&lang=tsx"
export * from "./Profile.vue?vue&type=script&setup=true&lang=tsx"

import "./Profile.vue?vue&type=style&index=0&id=9240f7f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9240f7f2"]])

export default __exports__